import { useMutation } from "@tanstack/react-query";

import { queryClient } from "#app/http/ReactQueryProvider";
import { logger } from "#app/monitoring/Logger";
import { showErrorToast } from "#app/notifications";
import { invalidatePart } from "#modules/parts/infra/invalidatePart";
import { PartWeightDto, updatePartWeight } from "#modules/parts/infra/updatePartWeight.api";

export const useUpdatePartWeight = ({
  partId,
  options,
}: {
  partId: string;
  options?: {
    onSuccess?: () => void;
  };
}) => {
  const { mutate, ...rest } = useMutation({
    mutationFn: ({ id, data }: { id: string; data: PartWeightDto }) => updatePartWeight(id, data),
    onSuccess: () => {
      void invalidatePart(queryClient, { partId });
      options?.onSuccess?.();
    },
    onError: (err: Error) => {
      logger.error(err);
      showErrorToast({
        title: err.message,
      });
    },
  });

  return { updatePartWeight: mutate, ...rest };
};
